function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.025 12.49H9.005V26.48H23.025V12.49Z",
  fill: "url(#paint0_linear_18_5526)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.965 29.47H3.02502V27.1C3.02502 26.75 3.30501 26.47 3.65501 26.47H28.345C28.695 26.47 28.975 26.75 28.975 27.1V29.47H28.965Z",
  fill: "#B9B4C3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.965 29.47H3.02502V27.1C3.02502 26.75 3.30501 26.47 3.65501 26.47H28.345C28.695 26.47 28.975 26.75 28.975 27.1V29.47H28.965Z",
  fill: "url(#paint1_linear_18_5526)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M28.965 29.47H3.02502V27.1C3.02502 26.75 3.30501 26.47 3.65501 26.47H28.345C28.695 26.47 28.975 26.75 28.975 27.1V29.47H28.965Z",
  fill: "url(#paint2_linear_18_5526)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M28.965 29.47H3.02502V27.1C3.02502 26.75 3.30501 26.47 3.65501 26.47H28.345C28.695 26.47 28.975 26.75 28.975 27.1V29.47H28.965Z",
  fill: "url(#paint3_linear_18_5526)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M4.04503 10.49H27.995V11.86C27.995 12.21 27.715 12.49 27.365 12.49H4.66504C4.31504 12.49 4.03503 12.21 4.03503 11.86V10.49H4.04503Z",
  fill: "#B8B1C0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M4.04503 10.49H27.995V11.86C27.995 12.21 27.715 12.49 27.365 12.49H4.66504C4.31504 12.49 4.03503 12.21 4.03503 11.86V10.49H4.04503Z",
  fill: "url(#paint4_linear_18_5526)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M4.04503 10.49H27.995V11.86C27.995 12.21 27.715 12.49 27.365 12.49H4.66504C4.31504 12.49 4.03503 12.21 4.03503 11.86V10.49H4.04503Z",
  fill: "url(#paint5_linear_18_5526)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M4.04503 10.49H27.995V11.86C27.995 12.21 27.715 12.49 27.365 12.49H4.66504C4.31504 12.49 4.03503 12.21 4.03503 11.86V10.49H4.04503Z",
  fill: "url(#paint6_linear_18_5526)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M8.99501 13.46H6.005V25.56H8.99501V13.46Z",
  fill: "url(#paint7_linear_18_5526)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M8.99501 13.46H6.005V25.56H8.99501V13.46Z",
  fill: "url(#paint8_linear_18_5526)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M14.655 13.46H11.665V25.56H14.655V13.46Z",
  fill: "url(#paint9_linear_18_5526)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M14.655 13.46H11.665V25.56H14.655V13.46Z",
  fill: "url(#paint10_linear_18_5526)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M20.3151 13.46H17.3251V25.56H20.3151V13.46Z",
  fill: "url(#paint11_linear_18_5526)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M20.3151 13.46H17.3251V25.56H20.3151V13.46Z",
  fill: "url(#paint12_linear_18_5526)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M25.975 13.46H22.985V25.56H25.975V13.46Z",
  fill: "url(#paint13_linear_18_5526)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M25.975 13.46H22.985V25.56H25.975V13.46Z",
  fill: "url(#paint14_linear_18_5526)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3261 3.01008L3.36616 9.75008C3.00616 9.95008 3.14615 10.5101 3.56615 10.5101H28.4462C28.8662 10.5101 29.0062 9.96008 28.6462 9.75008L16.6861 3.01008C16.2661 2.77008 15.7461 2.77008 15.3261 3.01008Z",
  fill: "url(#paint15_linear_18_5526)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3261 3.01008L3.36616 9.75008C3.00616 9.95008 3.14615 10.5101 3.56615 10.5101H28.4462C28.8662 10.5101 29.0062 9.96008 28.6462 9.75008L16.6861 3.01008C16.2661 2.77008 15.7461 2.77008 15.3261 3.01008Z",
  fill: "url(#paint16_linear_18_5526)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3261 3.01008L3.36616 9.75008C3.00616 9.95008 3.14615 10.5101 3.56615 10.5101H28.4462C28.8662 10.5101 29.0062 9.96008 28.6462 9.75008L16.6861 3.01008C16.2661 2.77008 15.7461 2.77008 15.3261 3.01008Z",
  fill: "url(#paint17_linear_18_5526)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3261 3.01008L3.36616 9.75008C3.00616 9.95008 3.14615 10.5101 3.56615 10.5101H28.4462C28.8662 10.5101 29.0062 9.96008 28.6462 9.75008L16.6861 3.01008C16.2661 2.77008 15.7461 2.77008 15.3261 3.01008Z",
  fill: "url(#paint18_linear_18_5526)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M10.005 12.49H5.01501V12.68C5.01501 13.13 5.37501 13.49 5.82501 13.49H9.19502C9.64502 13.49 10.005 13.13 10.005 12.68V12.49Z",
  fill: "url(#paint19_radial_18_5526)"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M10.005 12.49H5.01501V12.68C5.01501 13.13 5.37501 13.49 5.82501 13.49H9.19502C9.64502 13.49 10.005 13.13 10.005 12.68V12.49Z",
  fill: "url(#paint20_linear_18_5526)"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M10.005 12.49H5.01501V12.68C5.01501 13.13 5.37501 13.49 5.82501 13.49H9.19502C9.64502 13.49 10.005 13.13 10.005 12.68V12.49Z",
  fill: "url(#paint21_linear_18_5526)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M15.655 12.49H10.665V12.68C10.665 13.13 11.025 13.49 11.475 13.49H14.845C15.295 13.49 15.655 13.13 15.655 12.68V12.49Z",
  fill: "url(#paint22_radial_18_5526)"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M15.655 12.49H10.665V12.68C10.665 13.13 11.025 13.49 11.475 13.49H14.845C15.295 13.49 15.655 13.13 15.655 12.68V12.49Z",
  fill: "url(#paint23_linear_18_5526)"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M15.655 12.49H10.665V12.68C10.665 13.13 11.025 13.49 11.475 13.49H14.845C15.295 13.49 15.655 13.13 15.655 12.68V12.49Z",
  fill: "url(#paint24_linear_18_5526)"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M21.3251 12.49H16.3351V12.68C16.3351 13.13 16.6951 13.49 17.1451 13.49H20.5151C20.9651 13.49 21.3251 13.13 21.3251 12.68V12.49Z",
  fill: "url(#paint25_radial_18_5526)"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M21.3251 12.49H16.3351V12.68C16.3351 13.13 16.6951 13.49 17.1451 13.49H20.5151C20.9651 13.49 21.3251 13.13 21.3251 12.68V12.49Z",
  fill: "url(#paint26_linear_18_5526)"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M21.3251 12.49H16.3351V12.68C16.3351 13.13 16.6951 13.49 17.1451 13.49H20.5151C20.9651 13.49 21.3251 13.13 21.3251 12.68V12.49Z",
  fill: "url(#paint27_linear_18_5526)"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M26.985 12.49H21.995V12.68C21.995 13.13 22.355 13.49 22.805 13.49H26.175C26.625 13.49 26.985 13.13 26.985 12.68V12.49Z",
  fill: "url(#paint28_radial_18_5526)"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M26.985 12.49H21.995V12.68C21.995 13.13 22.355 13.49 22.805 13.49H26.175C26.625 13.49 26.985 13.13 26.985 12.68V12.49Z",
  fill: "url(#paint29_linear_18_5526)"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M26.985 12.49H21.995V12.68C21.995 13.13 22.355 13.49 22.805 13.49H26.175C26.625 13.49 26.985 13.13 26.985 12.68V12.49Z",
  fill: "url(#paint30_linear_18_5526)"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M21.985 26.48H26.975V26.29C26.975 25.84 26.615 25.48 26.165 25.48H22.795C22.345 25.48 21.985 25.84 21.985 26.29V26.48Z",
  fill: "url(#paint31_radial_18_5526)"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M21.985 26.48H26.975V26.29C26.975 25.84 26.615 25.48 26.165 25.48H22.795C22.345 25.48 21.985 25.84 21.985 26.29V26.48Z",
  fill: "url(#paint32_linear_18_5526)"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M21.985 26.48H26.975V26.29C26.975 25.84 26.615 25.48 26.165 25.48H22.795C22.345 25.48 21.985 25.84 21.985 26.29V26.48Z",
  fill: "url(#paint33_linear_18_5526)"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3351 26.48H21.3251V26.29C21.3251 25.84 20.9651 25.48 20.5151 25.48H17.1451C16.6951 25.48 16.3351 25.84 16.3351 26.29V26.48Z",
  fill: "url(#paint34_radial_18_5526)"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3351 26.48H21.3251V26.29C21.3251 25.84 20.9651 25.48 20.5151 25.48H17.1451C16.6951 25.48 16.3351 25.84 16.3351 26.29V26.48Z",
  fill: "url(#paint35_linear_18_5526)"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3351 26.48H21.3251V26.29C21.3251 25.84 20.9651 25.48 20.5151 25.48H17.1451C16.6951 25.48 16.3351 25.84 16.3351 26.29V26.48Z",
  fill: "url(#paint36_linear_18_5526)"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M10.665 26.48H15.655V26.29C15.655 25.84 15.295 25.48 14.845 25.48H11.475C11.025 25.48 10.665 25.84 10.665 26.29V26.48Z",
  fill: "url(#paint37_radial_18_5526)"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M10.665 26.48H15.655V26.29C15.655 25.84 15.295 25.48 14.845 25.48H11.475C11.025 25.48 10.665 25.84 10.665 26.29V26.48Z",
  fill: "url(#paint38_linear_18_5526)"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M10.665 26.48H15.655V26.29C15.655 25.84 15.295 25.48 14.845 25.48H11.475C11.025 25.48 10.665 25.84 10.665 26.29V26.48Z",
  fill: "url(#paint39_linear_18_5526)"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M5.005 26.48H9.99501V26.29C9.99501 25.84 9.635 25.48 9.185 25.48H5.815C5.365 25.48 5.005 25.84 5.005 26.29V26.48Z",
  fill: "url(#paint40_radial_18_5526)"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M5.005 26.48H9.99501V26.29C9.99501 25.84 9.635 25.48 9.185 25.48H5.815C5.365 25.48 5.005 25.84 5.005 26.29V26.48Z",
  fill: "url(#paint41_linear_18_5526)"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M5.005 26.48H9.99501V26.29C9.99501 25.84 9.635 25.48 9.185 25.48H5.815C5.365 25.48 5.005 25.84 5.005 26.29V26.48Z",
  fill: "url(#paint42_linear_18_5526)"
});

var _ref47 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_18_5526)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.7751 9.67L16.2551 2.56C16.1751 2.52 16.0951 2.5 16.0051 2.5C15.9251 2.5 15.8351 2.52 15.7551 2.56L3.23505 9.67C3.01505 9.8 2.93505 10.07 3.06505 10.29C3.15505 10.43 3.30505 10.51 3.46505 10.51C3.54505 10.51 3.62505 10.49 3.70505 10.45L15.7751 3.6C15.9151 3.52 16.0951 3.52 16.2351 3.6L28.3051 10.45C28.3751 10.49 28.465 10.51 28.545 10.51C28.705 10.51 28.8651 10.43 28.9451 10.29C29.0751 10.07 29.0051 9.79 28.7751 9.67Z",
  fill: "url(#paint43_linear_18_5526)"
}));

var _ref48 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_f_18_5526)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.1034 2.83008L28.7292 9.98444",
  stroke: "#DAD0DF",
  strokeWidth: 0.3,
  strokeLinecap: "round"
}));

var _ref49 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_f_18_5526)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.68237 10L15.5574 3.25",
  stroke: "url(#paint44_linear_18_5526)",
  strokeWidth: 0.3,
  strokeLinecap: "round"
}));

var _ref50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_18_5526",
  x: 3.00244,
  y: 2.4,
  width: 26.2074,
  height: 8.11001,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.2,
  dy: -0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.498039 0 0 0 0 0.462745 0 0 0 0 0.54902 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_5526"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_18_5526",
  x: 15.6534,
  y: 2.37993,
  width: 13.5259,
  height: 8.05459,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_18_5526"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_f_18_5526",
  x: 3.23235,
  y: 2.79985,
  width: 12.775,
  height: 7.65029,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15,
  result: "effect1_foregroundBlur_18_5526"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_18_5526",
  x1: 16.5026,
  y1: 11.6859,
  x2: 16.5026,
  y2: 26.48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#35303B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#65527A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_18_5526",
  x1: 29.2967,
  y1: 28.4035,
  x2: 28.1974,
  y2: 28.4035,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FCF2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FCF2FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_18_5526",
  x1: 16,
  y1: 26.47,
  x2: 16,
  y2: 27.2414,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CCC4D0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCC4D0",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_18_5526",
  x1: 2.92994,
  y1: 29.47,
  x2: 3.85646,
  y2: 29.47,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7A7680"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7A7680",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_18_5526",
  x1: 27.995,
  y1: 12.49,
  x2: 27.3585,
  y2: 12.49,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E8DFEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E8DFEF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_18_5526",
  x1: 16.015,
  y1: 12.7327,
  x2: 16.015,
  y2: 11.8983,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#726483"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#726483",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_18_5526",
  x1: 3.88551,
  y1: 12.49,
  x2: 4.76051,
  y2: 12.49,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#706D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#706D76",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_18_5526",
  x1: 6.006,
  y1: 19.5113,
  x2: 9.43233,
  y2: 19.5113,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#817C86"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.572917,
  stopColor: "#CFC7D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67166,
  stopColor: "#CFC7D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9A94A1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_18_5526",
  x1: 7.50001,
  y1: 13.2187,
  x2: 7.50001,
  y2: 13.8906,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#71677D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#71677D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_18_5526",
  x1: 11.666,
  y1: 19.5113,
  x2: 15.0923,
  y2: 19.5113,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7B7681"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.572917,
  stopColor: "#BFB9C8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67166,
  stopColor: "#BFB9C8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B2ABB8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_18_5526",
  x1: 13.16,
  y1: 13.2187,
  x2: 13.16,
  y2: 13.8906,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#71677D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#71677D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_18_5526",
  x1: 17.3261,
  y1: 19.5113,
  x2: 20.7524,
  y2: 19.5113,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6E6A73"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.572917,
  stopColor: "#CBC3D3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67166,
  stopColor: "#CBC3D3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BFB9C5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear_18_5526",
  x1: 18.8201,
  y1: 13.2187,
  x2: 18.8201,
  y2: 13.8906,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#71677D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#71677D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear_18_5526",
  x1: 22.986,
  y1: 19.5113,
  x2: 26.4123,
  y2: 19.5113,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#615E6A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.572917,
  stopColor: "#DAD2E2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67166,
  stopColor: "#DCD4E4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D5CDDC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear_18_5526",
  x1: 24.48,
  y1: 13.2187,
  x2: 24.48,
  y2: 13.8906,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#71677D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#71677D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear_18_5526",
  x1: 19.871,
  y1: 4.38499,
  x2: 16.0062,
  y2: 11.0725,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B3ACBB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ACA5B2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear_18_5526",
  x1: 20.4491,
  y1: 5.85374,
  x2: 20.0897,
  y2: 6.47875,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#645A6F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#645A6F",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear_18_5526",
  x1: 16.0062,
  y1: 11.0633,
  x2: 16.0062,
  y2: 10.3618,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#878190"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#878190",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear_18_5526",
  x1: 11.8699,
  y1: 5.53132,
  x2: 12.073,
  y2: 5.89069,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.344727,
  stopColor: "#857F8E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#857F8E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint19_radial_18_5526",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(8.79659 12.9931) rotate(180) scale(3.24521 0.936996)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#91899D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6D6976"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint20_linear_18_5526",
  x1: 7.51002,
  y1: 12.1802,
  x2: 7.51002,
  y2: 12.7605,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#564F5E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#564F5E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint21_linear_18_5526",
  x1: 7.51002,
  y1: 13.7706,
  x2: 7.51002,
  y2: 13.2978,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#564F5E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#564F5E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint22_radial_18_5526",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(14.4466 12.9931) rotate(180) scale(3.2452 0.936996)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#91899D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6D6976"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint23_linear_18_5526",
  x1: 13.16,
  y1: 12.1802,
  x2: 13.16,
  y2: 12.7605,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#564F5E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#564F5E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint24_linear_18_5526",
  x1: 13.16,
  y1: 13.7706,
  x2: 13.16,
  y2: 13.2978,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#564F5E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#564F5E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint25_radial_18_5526",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20.1166 12.9931) rotate(180) scale(3.2452 0.936996)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#91899D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6D6976"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint26_linear_18_5526",
  x1: 18.8301,
  y1: 12.1802,
  x2: 18.8301,
  y2: 12.7605,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#564F5E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#564F5E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint27_linear_18_5526",
  x1: 18.8301,
  y1: 13.7706,
  x2: 18.8301,
  y2: 13.2978,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#564F5E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#564F5E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint28_radial_18_5526",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(25.7766 12.9931) rotate(180) scale(3.2452 0.936996)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#91899D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6D6976"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint29_linear_18_5526",
  x1: 24.49,
  y1: 12.1802,
  x2: 24.49,
  y2: 12.7605,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#564F5E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#564F5E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint30_linear_18_5526",
  x1: 24.49,
  y1: 13.7706,
  x2: 24.49,
  y2: 13.2978,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#564F5E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#564F5E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint31_radial_18_5526",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(25.5613 25.9761) rotate(180) scale(2.58035 0.668458)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F7EDFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A29CA7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint32_linear_18_5526",
  x1: 22.9605,
  y1: 27.3512,
  x2: 23.8188,
  y2: 25.7776,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#656067"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#656067",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint33_linear_18_5526",
  x1: 27.6311,
  y1: 26.1562,
  x2: 26.3186,
  y2: 26.48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#807C87"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#807C87",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint34_radial_18_5526",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(19.9114 25.9761) rotate(180) scale(2.58035 0.668458)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E4DAEA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9A949E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint35_linear_18_5526",
  x1: 17.3106,
  y1: 27.3512,
  x2: 18.1689,
  y2: 25.7776,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#656067"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#656067",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint36_linear_18_5526",
  x1: 21.9811,
  y1: 26.1562,
  x2: 20.6686,
  y2: 26.48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#807C87"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#807C87",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint37_radial_18_5526",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(14.2413 25.9761) rotate(180) scale(2.58035 0.668458)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E4DAEA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9A949E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint38_linear_18_5526",
  x1: 11.6406,
  y1: 27.3512,
  x2: 12.4988,
  y2: 25.7776,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#656067"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#656067",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint39_linear_18_5526",
  x1: 16.3111,
  y1: 26.1562,
  x2: 14.9986,
  y2: 26.48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#807C87"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#807C87",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint40_radial_18_5526",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(8.58132 25.9761) rotate(180) scale(2.58035 0.668458)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E4DAEA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9A949E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint41_linear_18_5526",
  x1: 5.98053,
  y1: 27.3512,
  x2: 6.83881,
  y2: 25.7776,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#656067"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#656067",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint42_linear_18_5526",
  x1: 10.6511,
  y1: 26.1562,
  x2: 9.33858,
  y2: 26.48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#807C87"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#807C87",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint43_linear_18_5526",
  x1: 26.3806,
  y1: 8.53315,
  x2: 4.55145,
  y2: 8.53315,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ADA7B8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9F99A4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint44_linear_18_5526",
  x1: 5.33862,
  y1: 9.15625,
  x2: 19.1824,
  y2: 0.84375,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B3ADBA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B3ADBA",
  stopOpacity: 0
})));

function SvgClassicalBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassicalBuilding);
export default __webpack_public_path__ + "static/media/classical-building.8e1d7830.svg";
export { ForwardRef as ReactComponent };